import { InputHTMLAttributes } from 'react';
import { defaultCountries, usePhoneInput } from 'react-international-phone';
import { twJoin, twMerge } from 'tailwind-merge';

import { CountryPicker } from './CountryPicker';
import { PhoneInputOutput } from './types';
import { Label } from '../atomic/Label';

export type PhoneInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'onChange'> & {
  label?: string;
  errorMessage?: string;
  value?: string;
  onChange?: (_data: PhoneInputOutput) => void;
};

export const PhoneInput = ({ className, label, id, errorMessage, value, onChange, ...rest }: PhoneInputProps) => {
  const { phone, handlePhoneValueChange, inputRef, country, setCountry } = usePhoneInput({
    defaultCountry: 'fr',
    value,
    countries: defaultCountries,
    onChange,
  });

  return (
    <div>
      {label ? (
        <Label htmlFor={id} className={twJoin(!!errorMessage && 'text-red-700 dark:text-red-500')}>
          {label}
        </Label>
      ) : null}

      <div className="relative">
        <CountryPicker className="absolute left-0" country={country} setCountry={setCountry} />
        <input
          {...rest}
          type="text"
          ref={inputRef}
          id={id}
          className={twMerge(
            'bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5 pl-10 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500',
            !!errorMessage &&
              'bg-red-50 border border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500',
            className,
          )}
          value={phone}
          onChange={handlePhoneValueChange}
        />
      </div>
      {errorMessage ? <p className="mt-2 text-sm text-red-600 dark:text-red-500">{errorMessage}</p> : null}
    </div>
  );
};
